import { render } from "./MahjHead.vue?vue&type=template&id=2f6eda6f&scoped=true"
import script from "./MahjHead.vue?vue&type=script&lang=js"
export * from "./MahjHead.vue?vue&type=script&lang=js"

import "./MahjHead.vue?vue&type=style&index=0&id=2f6eda6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6eda6f"]])

export default __exports__